// extracted by mini-css-extract-plugin
module.exports = {"aboutUs":"style-module--aboutUs--L-k1M","member":"style-module--member--AJFWk","image":"style-module--image--21pex","imageContainer":"style-module--imageContainer--2_ELe"};